import AddSellSideColleague from './AddSellSideColleague.component';

export default AddSellSideColleague;